<template>
    <main id="renew2_top">
        <div class="renew2_top">
            <div class="mv">
                <div class="wrapper mv01">
                    <p class="mv01_txt" @click="changeMvTXTShow()">이력서 혁명!<br class="sp"> 아시아 최대급 이력서 작성 서비스</p>
                    <ul class="mv01_list" v-if="isMvTXTShow">
                        <li class="mv01_item">폼에 입력하는 것만으로 스마트폰이나 PC에서 이력서와 경력기술서를 쉽게 작성할 수 있습니다!</li>
                        <li class="mv01_item">작성된 이력서는 PDF로 본인에게 이메일 전송 가능</li>
                        <li class="mv01_item">전통적인 포맷과 디자인성이 높은 포맷도 준비!</li>
                    </ul>
                </div>
                <div class="wrapper mv02">
                    <span class="pc mv02-note"></span>
                    <img :src="getBaseURL + 'static/renew3_img/mv01.png'" alt="이력서 작성 서비스 야기슈" class="pc mv02-img">
                    <span class="pc mv02-txt"></span>
                    <span class="pc mv02-head"></span>
                    <span class="pc mv02-body"></span>
                    <img :src="getBaseURL + 'static/renew3_img/sp_mv.png'" alt="이력서 작성 서비스 야기슈" class="sp mv02-img">
                </div>
            </div>
            <div class="pc appeal" v-if="false">
                <ul class="wrapper appeal_list">
                    <li class="appeal_item">회원가입으로<br>백업기능</li>
                    <li class="appeal_item appeal_item02">무료로이력서<br>간단입력</li>
                    <li class="appeal_item appeal_item03">PDF로<br>저장 가능</li>
                </ul>
                <p class="wrapper appeal_txt">워드같은 편집소프트가 없어도 필요사항 입력만으로 누구나 간단하게 이력서를<br class="pc">브라우저에서 작성해서 PDF로
                    출력할 수
                    있는 광고없는
                    무료서비스</p>
            </div>
            <div class="wrapper format">
                <a href="format/rirekisho_design_001" class="format_item">
                    <div class="left left01" style="padding:15px;">
                        <p class="format_name">오리지널 이력서</p>
                        <p class="format_lead">차별화된 디자인</p>
                    </div>
                    <div class="right">
                        <img :src="getBaseURL + 'static/img/formats/design_format_001.png'" alt="기본 이력서"
                            class="right_img">
                    </div>
                </a>
                <a href="/kr/resume/format/rirekisho_kr_1" class="format_item">
                    <div class="left left02" style="padding:15px;">
                        <p class="format_name">스탠다드 이력서</p>
                        <p class="format_lead">회사입사용</p>
                    </div>
                    <div class="right">
                        <img :src="getBaseURL + 'static/img/formats/sample/rirekisho_kr1_01.png'" alt="표준 이력서"
                            class="right_img">
                    </div>
                </a>
                <a href="/kr/resume/format/rirekisho_kr_3" class="format_item">
                    <div class="left left03" style="padding:15px;">
                        <p class="format_name">경력기술서</p>
                        <p class="format_lead">경력직 지원자<br>목적별 작성 가능</p>
                    </div>
                    <div class="right">
                        <img :src="getBaseURL + 'static/img/formats/sample/rirekisho_kr3_01.png'" alt="경력기술서"
                            class="right_img">
                    </div>
                </a>
            </div>
            <div class="appeal">
                <ul class="wrapper appeal_list">
                    <li class="appeal_item">회원가입으로<br>백업기능</li>
                    <li class="appeal_item appeal_item02">무료로이력서<br>간단입력</li>
                    <li class="appeal_item appeal_item03">PDF로<br>저장 가능</li>
                </ul>
                <p class="wrapper appeal_txt">워드같은 편집소프트가 없어도 필요사항 입력만으로 누구나 간단하게 이력서를<br class="pc">브라우저에서 작성해서 PDF로
                    출력할 수
                    있는 광고없는
                    무료서비스</p>
            </div>
            <div class="how">
                <div class="how_container">
                    <h3><img :src="getBaseURL + 'static/renew3_img/how_title.png'" alt="야기슈 사용법"></h3>
                    <ul class="wrapper how_list">
                        <li class="how_item">
                            <p class="how_txt"><span>1</span> 양식 선택</p>
                            <img :src="getBaseURL + 'static/renew3_img/icon_how01.png'" alt="양식 선택" class="how_img">
                        </li>

                        <li class="how_item pc">
                            <img :src="getBaseURL + 'static/renew3_img/icon_how02.png'" alt="이력서 만들기" class="how_img">
                            <p class="how_txt"><span>2</span> 이력서 만들기</p>
                        </li>
                        <li class="how_item sp">
                            <p class="how_txt"><span>2</span> 이력서 만들기</p>
                            <img :src="getBaseURL + 'static/renew3_img/icon_how02.png'" alt="이력서 만들기" class="how_img">
                        </li>
                        <li class="how_item">
                            <p class="how_txt"><span>3</span> PDF 출력</p>
                            <img :src="getBaseURL + 'static/renew3_img/icon_how03.png'" alt="PDF 출력" class="how_img">
                        </li>
                    </ul>
                    <a href="" class="link">사용법 보기</a>
                </div>
                <div class="wrapper btn_container">
                    <a href="/kr/resume/format/rirekisho_design_001" class="cv-btn">이력서를 한 곳에서 쉽게 만들자!<span></span></a>
                </div>
            </div>
            <div class="article">
                <div data-v-0c76a9cf class="wrapper article_container">
                    <h3 class="article_h3">유용한 정보</h3>
                    <ul class="article_linklist">
                        <li class="article_item">
                            <a href="/kr/resume/article/guide01" class="article_link">이력서 작성 완벽 가이드｜양식, 예문, 꿀팁까지 총정리</a>
                        </li>
                        <li class="article_item">
                            <a href="/kr/resume/article/guide02" class="article_link">이력서 학력 기재법 완벽 정리｜작성 순서, 주의사항,
                                예시까지</a>
                        </li>
                        <li class="article_item">
                            <a href="/kr/resume/article/guide03" class="article_link">이력서 경력사항 작성법 완전 정리｜경력 기술서 예시 & 직무별
                                팁</a>
                        </li>
                        <li class="article_item">
                            <a href="/kr/resume/article/guide04" class="article_link">이력서 지원동기 예시 & 꿀팁 ! 취업 성공 첫걸음</a>
                        </li>
                        <li class="article_item">
                            <a href="/kr/resume/article/guide05" class="article_link">자기 PR 이렇게 쓰면 합격률 UP! 실전 팁 & 예시</a>
                        </li>
                        <li class="article_item">
                            <a href="/kr/resume/article/guide06" class="article_link">이력서 합격 공식! 바로 적용할 수 있는 실전 팁</a>
                        </li>
                    </ul>
                    <a href="/kr/resume/article" class="articlelist">기사 목록</a>
                </div>
            </div>
        </div>
    </main>
</template>
<style lang="css" src="@/assets/css/renew2_style.css"></style>


<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<style lang="scss" scoped>
#renew2_top .wrapper {
    width: 768px;
    margin: 0 auto;
}

#renew2_top .mv {
    background: repeating-linear-gradient(#57B871, #57B871 1px, #0f9934 1px, #0f9934 60px);
    color: #fff;
    font-weight: bold;
    padding: 30px 0 0;
}

#renew2_top .mv01_list {
    text-align: left;
    margin: 20px 0;
    font-size: 1rem;
}

#renew2_top .mv01_txt {
    text-align: center;
    background: #E95B10;
    border-radius: 70px;
    padding: 5px 0;
    font-size: 1rem;
    box-shadow: 0 4px 0 #d01a0a;
    position: relative;
    z-index: 1;
}

#renew2_top .mv01_txt:hover {
    transform: translateY(4px);
    box-shadow: none;
}

#renew2_top .mv01_txt::after {
    position: absolute;
    content: "";
    width: 15px;
    height: 15px;
    border: 0;
    border-top: 3px solid #fff;
    border-right: 3px solid #fff;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    top: 0;
    right: 30px;
    bottom: 5px;
    margin: auto;
}

#renew2_top .mv02 {
    position: relative;
    text-align: center;
    /*background-image: url(/kr/resume/static/renew3_img/back03.png);
    background-position: center;
    background-repeat: no-repeat;*/
    width: 100%;
    margin: -30px calc(50% - 50vw) 0;
    overflow: hidden;
}

#renew2_top .mv02-head,
#renew2_top .mv02-body,
#renew2_top .mv02-note {
    position: relative;
}

#renew2_top .mv02-note::before {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/mvnote01.png);
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: contain;
    vertical-align: middle;
    width: 150px;
    height: 165px;
    transform: rotate(-15deg);
    left: -150px;
    bottom: 140px;
}

#renew2_top .mv02-note::after {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/mvnote02.png);
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: contain;
    vertical-align: middle;
    width: 150px;
    height: 165px;
    transform: rotate(15deg);
    left: -150px;
    bottom: 0;
}

#renew2_top .mv02-head::before {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/mv02.png);
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: contain;
    vertical-align: middle;
    width: 160px;
    height: 170px;
    bottom: 30px;
    right: -100px;
    z-index: 5;
}

#renew2_top .mv02-body::before {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/mv03.png);
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: contain;
    vertical-align: middle;
    width: 110px;
    height: 80px;
    bottom: -10px;
    right: -70px;
    z-index: 2;
}

#renew2_top .mv02-body::after {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/back03.png);
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: contain;
    vertical-align: middle;
    width: 580px;
    height: 300px;
    bottom: 0;
    right: -300px;
    z-index: 1;
}

#renew2_top .mv02-txt {
    position: relative;
}

#renew2_top .mv02-txt::after {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/mv04.png);
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: contain;
    vertical-align: middle;
    width: 180px;
    height: 150px;
    right: -180px;
    z-index: 5;
}

#renew2_top .mv02-img {
    position: relative;
    max-width: 500px;
    width: 100%;
    margin-top: 10px;
    z-index: 3;
}

#renew2_top .mv01_item {
    position: relative;
    padding-left: 50px;
}

#renew2_top .mv01_item::before {
    position: absolute;
    background-image: url(/kr/resume/static/renew3_img/icon_check.png);
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: contain;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    content: "";
}

#renew2_top .mv01 {
    margin-bottom: 40px;
}

#renew2_top .appeal {
    background: #EDF5E8;
    padding: 50px 0;
}

#renew2_top .appeal_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 30px;
}

#renew2_top .appeal_item {
    position: relative;
    background: #004D40;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    width: calc(100% / 3 - 10px);
    padding: 80px 20px 20px;
    border-radius: 20px;
    box-shadow: 5px 5px 10px 0px rgba(15, 153, 52, 0.06);
}

#renew2_top .appeal_item::after {
    position: absolute;
    content: "";
    display: inline-block;
    width: 70px;
    height: 70px;
    background-image: url(/kr/resume/static/renew3_img/icon_appeal01.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: middle;
    top: 20px;
    right: 20px
}

#renew2_top .appeal_item02::after {
    background-image: url(/kr/resume/static/renew3_img/icon_appeal02.png);
}

#renew2_top .appeal_item03::after {
    background-image: url(/kr/resume/static/renew3_img/icon_appeal03.png);
}

#renew2_top .appeal_txt {
    text-align: center;
}

#renew2_top .format {
    padding: 50px 0 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

#renew2_top .format_item {
    display: flex;
    justify-content: space-between;
    width: calc(100% / 2 - 10px);
    background: #E95B10;
    border-radius: 20px 20px 0 20px;
    color: #fff;
    font-weight: bold;
    margin-bottom: 30px;
    box-shadow: 5px 5px 10px 0px rgba(233, 91, 16, 0.06);
}

#renew2_top .format_item:hover {
    opacity: 1;
    text-decoration: none;
    transform: scale(1.05);
}

#renew2_top .format .left {
    position: relative;
    padding: 30px;
}

#renew2_top .format .left::after {
    position: absolute;
    content: " A4\A 2장이상";
    white-space: pre;
    color: #fff;
    opacity: 0.8;
    bottom: 30px;
}

#renew2_top .format .left02::after {
    content: " A4\A 2장";
}

#renew2_top .format .left03::after {
    content: " A4";
}

#renew2_top .format_name {
    font-size: 22px;
}

#renew2_top .format_lead {
    font-size: 16px;
}

#renew2_top .format .right {
    position: relative;
}

#renew2_top .right_img {
    height: 200px;
    width: 154px;
    object-fit: cover;
    object-position: top;
}

#renew2_top .format .right::before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    border-top: 80px solid transparent;
    border-right: 80px solid #E95B10;
    z-index: 100;
}

#renew2_top .format .right::after {
    position: absolute;
    content: "클릭";
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    right: 8px;
    bottom: 8px;
    transform: rotate(-45deg);
    color: #fff;
    z-index: 200;
}

#renew2_top .how {
    text-align: center;
    margin-bottom: 50px;
}

#renew2_top .how_container {
    position: relative;
    background: #EDF5E8;
    margin-bottom: 50px;
    padding: 50px 0;
}

#renew2_top .how_container::before {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/back01.png);
    background-position: 400px center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 2000px;
    height: 300px;
    right: 0;
}

#renew2_top .how h3 {
    position: relative;
    z-index: 1;
}

#renew2_top .how h3 img {
    max-width: 300px;
}

#renew2_top .how_list {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 30px auto 50px;
    z-index: 1;
}

#renew2_top .how_item {
    width: calc(100% / 3 - 10px);
}

#renew2_top .how_txt {
    font-weight: bold;
    color: #004D40;
    font-size: 24px;
}

#renew2_top .how_txt span {
    display: inline-block;
    color: #fff;
    background: #E95B10;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    text-align: center;
    line-height: 34px;
}

#renew2_top .how_img {
    height: 120px;
    margin: 10px;
}

#renew2_top .how .link {
    position: relative;
    display: block;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    max-width: 300px;
    padding: 15px 0;
    margin: 0 auto;
    border-radius: 20px;
    background: #0F9934;
}

#renew2_top .how .link::after {
    position: absolute;
    content: '';
    width: 15px;
    height: 15px;
    border: 0;
    border-top: solid 3px #fff;
    border-right: solid 3px #fff;
    transform: rotate(45deg);
    top: 0;
    right: 30px;
    bottom: 0;
    margin: auto;
}

#renew2_top .how .link:hover {
    opacity: 1;
    text-decoration: none;
    transform: scale(1.05);
}

#renew2_top .cv-btn {
    position: relative;
    display: block;
    width: calc(100% - 100px);
    padding: 40px 30px 20px;
    text-align: left;
    color: #fff;
    font-weight: bold;
    font-size: 30px;
    background: #E95B10;
    border-radius: 20px;
    box-shadow: 5px 5px 10px 0px rgba(233, 91, 16, 0.06);
}

#renew2_top .btn_container {
    position: relative;
}

#renew2_top .btn_container::after {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew3_img/kryagi03.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 200px;
    height: 200px;
    right: 0;
    bottom: -20px;
}

#renew2_top .cv-btn span {
    position: relative;
}

#renew2_top .cv-btn span::after {
    position: absolute;
    content: '';
    width: 20px;
    height: 20px;
    border: 0;
    border-top: solid 3px #fff;
    border-right: solid 3px #fff;
    transform: rotate(45deg);
    top: 0;
    right: -20px;
    bottom: 5px;
    margin: auto;
}

#renew2_top .cv-btn:hover {
    opacity: 1;
    text-decoration: none;
    transform: scale(1.05);
}

#renew2_top .article {
    background: #FFFFE8;
    padding: 50px 0;
}

#renew2_top .article_h3 {
    text-align: center;
    font-size: 1.4rem;
    margin-bottom: 25px;
}

#renew2_top .article_item {
    border-bottom: 1px solid #eeeeee;
    width: 100%;
}

#renew2_top .article_item:last-child {
    border-bottom: 0;
}

#renew2_top .article_link {
    display: block;
    padding: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#renew2_top .articlelist {
    display: block;
    text-align: right;
}


@media screen and (max-width: 640px) {
    #renew2_top .wrapper {
        max-width: 100%;
        padding: 0 15px;
    }

    #renew2_top .mv02 {
        background-image: url(/kr/resume/static/renew3_img/back03.png);
        background-position: center;
        background-repeat: no-repeat;
        margin-top: 0;
        background-size: cover;
    }

    #renew2_top .appeal {
        padding-bottom: 0;
    }

    #renew2_top .appeal_item {
        width: 100%;
        padding-top: 20px;
        margin-bottom: 20px;
    }

    #renew2_top .appeal_item:last-child {
        margin-bottom: 0;
    }

    #renew2_top .format {
        padding: 50px 15px 30px;
    }

    #renew2_top .format_item {
        width: 100%;
    }

    #renew2_top .how_item {
        width: 100%;
    }

    #renew2_top .cv-btn {
        width: 100%;
        z-index: 1;
    }

    #renew2_top .format .right::after {
        content: "클릭";
        right: 2px;
        bottom: 12px;
    }

    #renew2_top .format_item {
        margin-bottom: 20px;
    }

    #renew2_top .how_container::before {
        background-position: center;
        background-image: url(/kr/resume/static/renew3_img/back02.png);
        width: 550px;
        height: 480px;
        bottom: 200px;
    }

    #renew2_footer .footer_link {
        display: block;
    }

    #renew2_footer .link-item:after {
        content: none;
    }

    #renew2_top .btn_container:after {
        width: 100px;
        height: 100px;
        bottom: 155px;
        z-index: 5;
    }
}
</style>

<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
export default {
    components: {
        'blog-widget': blogWidget,
        'yagi-omikuji': YagiOmikuji,
        Slick
    },
    data: function () {
        return {
            is_not_midnight: true,
            recentEdit: {
                FormatId: ''
            },
            isWhat: true,
            isWho: false,
            selectedKind: '',
            selectedHash: '',
            mvBanner: 1,
            isMvTXTShow: false,
            slickOptions: {
                centerMode: true,
                // centerPadding: '-20px',
                variableWidth: false,
                accessibility: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 4000,
                asNavFor: '.slider-nav',
                speed: 400
            },
            slickNavOptions: {
                focusOnSelect: true,
                asNavFor: '.slider-for',
                variableWidth: false,
                slidesToShow: 5,
                centerPadding: '20px',
            }
        }
    },
    methods: {
        searchHash: function (_hash) {
            this.selectedHash = _hash
        },
        searchKind: function (_kind) {
            this.selectedKind = _kind
        },
        reload: function () {
            location.reload(true)
        },
        recentEditClass: function (format) {
            if (!this.recentEdit) return
            if (this.recentEdit.FormatId === format.id) {
                return {
                    'current-edit': true
                }
            }
        },
        loadRecentEdit: function () {
            const app = this
            this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
                if (err) {
                    console.log(err)
                }
                if (data) {
                    app.recentEdit = data
                }
            })
        },
        updateRecentEdit: function (data) {
            if (data) {
                this.recentEdit = data
            }
        },
        toggleButton: function () {
            if (this.isWhat) {
                this.isWhat = false
                this.isWho = true
            } else {
                this.isWhat = true
                this.isWho = false
            }
            this.selectedKind = ''
            this.selectedHash = ''
        },
        getSelectedHash: function (classname, val) {
            if (val == this.selectedHash) {
                return classname + ' select'
            } else {
                return classname
            }

        },
        changeMvTXTShow: function () {
            if (this.isMvTXTShow) {
                this.isMvTXTShow = false
            } else {
                this.isMvTXTShow = true
            }

        },
        getSelectedKind: function (classname, val) {
            if (val == this.selectedKind) {
                return classname + ' select'
            } else {
                return classname
            }

        }
    },
    computed: {
        getBaseURL: function () {
            return process.env.BASE_URL
        },
        forSearchHashs: function () {
            let _rtVal = []
            if (this.selectedHash) {
                for (let obj of this.$site.rirekishoFormatsIndex) {
                    for (let _hash of obj.hashs) {
                        if (_hash == this.selectedHash) {
                            _rtVal.push(obj)
                        }
                    }
                }
                return _rtVal
            } else {
                return this.$site.rirekishoFormatsIndex
            }
        }
    },
    created: function () {
        // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
        this.loadRecentEdit()
        const now = new Date()
        if (now.getHours() >= 0 && now.getHours() < 6) {
            this.is_not_midnight = false
        }
        this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
        this.$eventHub.$on('reload', this.reload)
    },
    destroyed: function () {
        this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
        this.$eventHub.$off('reload', this.reload)
    }
}
</script>
